export default "__VITE_ASSET__BYVfoLfK__"